import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 3.95A3.91 3.91 0 0 1 3.95 0h16.1C22.28 0 24 1.851 24 3.95v16.1A3.91 3.91 0 0 1 20.05 24H3.95A3.91 3.91 0 0 1 0 20.05zm5.684 3.22c0-.86.726-1.586 1.586-1.586s1.587.726 1.587 1.587v1.586H7.27c-.86 0-1.586-.726-1.586-1.586Zm4.673 0v1.587h3.386V7.171a3.107 3.107 0 0 1 3.087-3.087 3.107 3.107 0 0 1 3.086 3.087 3.107 3.107 0 0 1-3.086 3.086h-1.587v3.386h1.587a3.107 3.107 0 0 1 3.086 3.087 3.107 3.107 0 0 1-3.086 3.086 3.107 3.107 0 0 1-3.087-3.086v-1.587h-3.386v1.587a3.107 3.107 0 0 1-3.087 3.086 3.107 3.107 0 0 1-3.086-3.086 3.107 3.107 0 0 1 3.086-3.087h1.587v-3.386H7.27a3.107 3.107 0 0 1-3.086-3.086A3.107 3.107 0 0 1 7.27 4.084a3.107 3.107 0 0 1 3.087 3.087Zm0 6.473v-3.386h3.386v3.386zm6.473-4.886h-1.587V7.171c0-.86.726-1.587 1.587-1.587.86 0 1.586.726 1.586 1.587 0 .86-.726 1.586-1.586 1.586m-1.587 7.973v-1.587h1.587c.86 0 1.586.726 1.586 1.587 0 .86-.726 1.586-1.586 1.586s-1.587-.726-1.587-1.586M7.27 15.143h1.587v1.587c0 .86-.726 1.586-1.587 1.586-.86 0-1.586-.726-1.586-1.586s.726-1.587 1.586-1.587",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const computerKeyboardCommandCmdControlCtrl = { render };
export {
  computerKeyboardCommandCmdControlCtrl as default,
  render
};
//# sourceMappingURL=computer-keyboard-command-cmd-control-ctrl.svg.js.map
